import  api, { globalErrorHandler } from "../Api"

export const GET_USERS_BY_ROL = "GET_USERS_BY_ROL";
export const UPDATE_USER_BY_ROLE = "UPDATE_USER_BY_ROLE";
export const ADD_USER_BY_ROLE = "ADD_USER_BY_ROLE";
export const UPDATE_ROLE = "UPDATE_ROLE";
export const GET_ROLES_BY_MODULE = "GET_ROLES_BY_MODULE";
export const CONF_LOADING = "CONF_LOADING";
export const CONF_ERROR = "CONF_ERROR";

const config = {
  headers: {
      'content-type': 'application/json',
  }
};

export const GetUsersByRol = (rol) => {
  
  return async dispatch => {
    dispatch({
      type: CONF_LOADING
    });
    await api.get(`/User/GetAllUserByRolCode/${rol}`,config).then(res => 
      dispatch({
        type: GET_USERS_BY_ROL,
        data: res.data
        })
      ).catch(globalErrorHandler); 
  };
};

export const GetRolesByModule = (module) => {
  const config = {
      headers: {
          'content-type': 'application/json',
      }
    }  
  return async dispatch => {
    dispatch({
      type: CONF_LOADING
    });
    await api.get(`/Module/GetRolesByModule?moduleCode=${module}`,config).then(res => {
      dispatch({
        type: GET_ROLES_BY_MODULE,
        data: res.data
      });
    })
    .catch((error) => {
      globalErrorHandler(error);
      dispatch({
        type: CONF_ERROR 
      })
    });
  };
};

export const AddUserByRole = (payload) => {
  return async dispatch => {
      dispatch({
          type: CONF_LOADING
      });

      api.post(`/User/AddUser`, 
      payload, config).then(res => {
          dispatch({
              type: ADD_USER_BY_ROLE,
              payload: res.data
          });
      })
      .catch((error) => {
        globalErrorHandler(error);
        dispatch({
          type: CONF_ERROR 
        })
      });
  };
};

export const UpdateUserByRole = (payload) => {
  return async dispatch => {
      dispatch({
          type: CONF_LOADING
      });

      api.put(`/User/UpdateUser`, 
      payload, config).then(res => {
          dispatch({
              type: UPDATE_USER_BY_ROLE,
              payload: res.data
          });
      })
      .catch((error) => {
        globalErrorHandler(error);
        dispatch({
          type: CONF_ERROR 
        })
      });
  };
};

export const UpdateRole = (payload) => {
  return async dispatch => {
      dispatch({
          type: CONF_LOADING
      });

      api.put(`/Role/Update`, 
      payload, config).then(res => {
          dispatch({
              type: UPDATE_ROLE,
              payload: res.data
          });
      })
      .catch((error) => {
        globalErrorHandler(error);
        dispatch({
          type: CONF_ERROR 
        })
      });
  };
};
